import React, {Component} from 'react';
import ClinicPatientList from "./ClinicPatientList";
import PhysicianService from '../../api/services/PhysicianService';
import DrMiniForm from '../../views/Clients/forms/DrMiniForm';
import { PhysicianDetailCard } from '../../views/Clients/PhysicianDetails';

export default class ClinicPhysicianList extends Component{
    /*createModalTitle = 'New Physician';
    get service(){
        return PhysicianService;
    }*/

    render(){
        let {service, miniForm, ...props} = this.props;
        return(
            <ClinicPatientList hideEdit={true} service={PhysicianService} miniForm={DrMiniForm} createModalTitle='New Physician' detailCard={PhysicianDetailCard} {...props} />
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/datalists/ClinicPhysicianList.js